import React from "react";
import { Box, Tooltip, UnstyledButton } from "@mantine/core";
import styles from "./CheckoutPanel.module.css";

interface MethodPillProps {
  icon: React.ReactNode;
  label: string;
  /** Dimmed suffix, e.g. "(Buy Now, Pay Later)". */
  subLabel?: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  /** Shown when disabled (or always, if provided) to explain the state. */
  tooltip?: string;
}

/** Payment-method pill with the teal selected inset ring. */
export default function MethodPill({
  icon,
  label,
  subLabel,
  selected,
  onClick,
  disabled = false,
  tooltip,
}: MethodPillProps) {
  const classNames = [styles.methodPill];
  if (selected) classNames.push(styles.methodPillSelected);
  if (disabled) classNames.push(styles.methodPillDisabled);

  const pill = (
    <UnstyledButton
      className={classNames.join(" ")}
      onClick={() => {
        if (!disabled) onClick();
      }}
      aria-pressed={selected}
      aria-disabled={disabled}
    >
      <Box className={styles.methodPillIcon}>{icon}</Box>
      {label}
      {subLabel && (
        <Box component="span" className={styles.methodPillSub}>
          {subLabel}
        </Box>
      )}
    </UnstyledButton>
  );

  if (tooltip) {
    return <Tooltip label={tooltip}>{pill}</Tooltip>;
  }
  return pill;
}
